export default class TechnicianBooking {
  constructor (bookingData) {
    this.id = bookingData.id
    this.name = bookingData.name
    this.opened = bookingData.opened
    this.createdBy = bookingData.createdBy
    this.createdAt = bookingData.createdAt
    this.code = bookingData.code
    this.location = bookingData.location
    this.eventStartAt = bookingData.eventStartAt
    this.eventEndAt = bookingData.eventEndAt
    this.eventType = bookingData.eventType
    this.catering = bookingData.catering
    this.broadcasted = bookingData.broadcasted
    this.docs = bookingData.docs
    this.docExtra = bookingData.docExtra ? bookingData.docExtra.name : null
    this.positions = bookingData.positions
  }

  get getId () {
    return this.id
  }

  get getOpened () {
    return this.opened
  }

  updateOpened (opened) {
    this.opened = opened
  }

  get getName () {
    return this.name
  }

  get getCode () {
    return this.code
  }

  get getCreatedBy () {
    return this.createdBy
  }

  get getCreatedAt () {
    return new Date(this.createdAt.replace(' ', 'T'))
  }

  get getEventType () {
    return this.eventType
  }

  get getLocation () {
    return this.location
  }

  get getCompleteLocation () {
    if (!this.location) {
      return ''
    }
    return this.location.name + ', ' +
      this.location.administrative + ', ' +
      this.location.country
  }

  get getEventStartAt () {
    if (!this.eventStartAt) {
      return
    }
    return new Date(this.eventStartAt.replace(' ', 'T'))
  }

  get getEventEndAt () {
    if (!this.eventEndAt) {
      return
    }
    return new Date(this.eventEndAt.replace(' ', 'T'))
  }

  get getCatering () {
    return this.catering
  }

  get getBroadcasted () {
    return this.broadcasted
  }

  get getDocs () {
    return this.docs
  }

  get getDocExtra () {
    return this.docExtra
  }

  get getPositions () {
    return this.positions
  }

  get hasPositions () {
    return this.positions.length > 0
  }

  get getEventDate () {
    const startDate = this.getEventStartAt
    const endDate = this.getEventEndAt
    const startMonthYear = startDate.getFullYear().toString() + startDate.getMonth().toString()
    const endMonthYear = endDate.getFullYear().toString() + endDate.getMonth().toString()
    if (startMonthYear === endMonthYear) {
      return this.getShortDate(startDate, endDate)
    }
    return this.getLongDate(startDate, endDate)
  }

  get getShortLocation () {
    return this.location.name + ' (' + this.location.administrative + ')'
  }

  getLongDate (startDate, endDate) {
    return startDate.getDate() + ' ' +
      this.getLocalizedMonthNameByMonth(startDate.getMonth()) + ' ' +
      startDate.getFullYear() + ' - ' +
      endDate.getDate() + ' ' +
      this.getLocalizedMonthNameByMonth(endDate.getMonth()) + ' ' +
      endDate.getFullYear()
  }

  getShortDate (startDate, endDate) {
    return startDate.getDate() + ' - ' + endDate.getDate() + ' ' +
      this.getLocalizedMonthNameByMonth(endDate.getMonth()) + ' ' +
      endDate.getFullYear()
  }

  getLocalizedMonthNameByMonth (month) {
    return ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'][month]
  }
}
